/* eslint-disable react/no-danger */
import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';

import { AtlassianAccountOnboardingLinks } from './AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';

const format = forNamespace(['aa onboarding', 'dialog']);
interface SuccessProps {
  aaEmail: string;
  orgName: string;
  onDismiss: () => void;
  image?: HTMLImageElement;
}

export const Success: FunctionComponent<SuccessProps> = ({
  aaEmail,
  orgName,
  onDismiss,
  image,
}) => (
  <OnboardingDialog
    closeDialog={onDismiss}
    title={format('your account is all set up')}
    helpLink={AtlassianAccountOnboardingLinks.Help}
    image={image}
  >
    <div>
      <p
        dangerouslySetInnerHTML={{
          __html: format('be mindful of personal content', {
            org: orgName,
            transferBoardsUrl: AtlassianAccountOnboardingLinks.TransferBoards,
          }),
        }}
      />
    </div>
    <div>
      <p
        dangerouslySetInnerHTML={{
          __html: format('going forward log in with Atlassian', {
            atlassianAccountUrl:
              AtlassianAccountOnboardingLinks.AtlassianAccount,
          }),
        }}
      />
    </div>
    <div className={styles.primaryEmail}>{aaEmail}</div>
    <p
      dangerouslySetInnerHTML={{
        __html: format('if you have questions help pages', {
          helpUrl: AtlassianAccountOnboardingLinks.Help,
        }),
      }}
    />

    <div className={styles.section}>
      <PrimaryButton onClick={() => onDismiss()}>
        {format('take me back to trello button')}
      </PrimaryButton>
    </div>
  </OnboardingDialog>
);
